import { createI18n } from 'vue-i18n'
import { useI18n } from 'vue-i18n'
import { nextTick } from 'vue'

const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  globalInjection: true,
  messages: {},
})

export const updateLocaleAsync = async(localeId, localizations) => {
  Object.keys(localizations).forEach(language => {
    const langDict = {}
    localizations[language].forEach(localization => {
      langDict[localization.key] = localization.value
    })
    i18n.global.setLocaleMessage(language, langDict)
  })

  i18n.global.locale.value = localeId

  return nextTick()
}

export const getTranslatedField = (item, field = 'name', languageCode = i18n.global.locale.value) => {
  if (!item.translations) {
    return item[field]
  }
  let currentTranslation = item.translations[languageCode]
  if (!currentTranslation) {
    currentTranslation = item.translations[i18n.global.fallbackLocale.value]
  }
  return currentTranslation?.[field] || item?.[field]
}

export const getTranslatedItems = (items, languageCode = i18n.global.locale.value) => {
  return items && items.map((item) => {
    return {
      ...item,
      name: getTranslatedField(item, 'name', languageCode)
    }
  })
}

export const getLocalizedItems = (items, prefix = '') => {
  return items.map((item) => {
    return {
      ...item,
      name: prefix !== '' ? i18n.global.t(`${prefix}.${item.name}`) : i18n.global.t(item.name)
    }
  })
}

export const getLocalizedItem = (item) => {
  const locale = i18n.global.locale.value
  return {
    ...item,
    name: item.translations?.[locale]?.name || ''
  }
}

let i18nInstance = null
export const getI18n = () => {
  if (!i18nInstance) {
    i18nInstance = useI18n()
  }
  return i18nInstance
}

export default i18n
